






















































































































import Vue from 'vue';
import SidePage from '../../../../common/components/ui/SidePage/index.vue';
import customerVuex from '../../../../customer/vuex/common';
import scheduleRuleVuex from '../../../vuex/common';
import SelectTargetPage from './SelectTargetPage.vue';
import CustomerSetBox from './CustomerSetBox.vue';
import ScheduleMsgBox from './ScheduleMsg.vue';
import ScheduleTplMsgDisplay from './ScheduleTplMsgDisplay.vue';
import CustomerFilterDisplay from '../../../../mass/components/mpgroup/CustomerFilterDisplay.vue';
import CustomerExpectedCount from '../../../../mass/components/common/CustomerExpectedCount.vue';
import { ScheduleMsg, WxTpl, transValue, transDiv} from '../../../models/ScheduleMsg';
import { ScheduleRuleType } from '../../../models/ScheduleRule';
import { PeriodicFreq } from '../../../models/ScheduleRuleContext';
import PeriodicFreqBox from './PeriodicFreq.vue';
import ruleClient from '../../../apis';
import { CustomerFilter } from '../../../../customer/models/CustomerFilter';
import format from '../../../../customer/components/filter/makeCustomerQuery';
import customerClient from '../../../../customer/apis';

const WEEK_DAYS_TEXT = ['', '一', '二', '三', '四', '五', '六', '日'];
const cFilter: CustomerFilter | undefined = undefined;
const groupLoaded = false;

export default Vue.extend({
  mixins: [customerVuex, scheduleRuleVuex],
  components: {
    SidePage,
    SelectTargetPage,
    PeriodicFreqBox,
    ScheduleMsgBox,
    ScheduleTplMsgDisplay,
    CustomerFilterDisplay,
    CustomerExpectedCount,
    CustomerSetBox,
  },
  data() {
    return {
      hasSetCustomers: false,
      showSelectTargetPage: false,
      showScheduleMsg: false,
      showPeriodicFreq: false,
      creating: false,
      cFilter,
      groupLoaded,
    };
  },
  computed: {
    weekDays(): string {
      const weekly = this.scheduleRule.ruleContext.Periodic.freq.Weekly;
      if (weekly && weekly.days.length > 0) {
        return weekly.days.sort().map((r: any) => WEEK_DAYS_TEXT[r]).join('、');
      } else {
        return '';
      }
    },
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
  },
  methods: {
    loadExtraData() {
      customerClient.getGroups().success(r => {
        this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
        customerClient.getMemberCards().success(r => {
          this.$store.commit('SET_MEMBER_CARDS', r);
          this.groupLoaded = true;
        });
      });
    },
    updateScheduleRuleName(event: Event) {
      this.$store.commit('UPDATE_SCHEDULE_RULE_NAME', (event.target as any)['value']);
    },
    hasSetFreq(): boolean {
      return this.scheduleRule.ruleContext.Periodic.freq !== undefined;
    },
    freq(): PeriodicFreq {
      return this.scheduleRule.ruleContext.Periodic.freq;
    },
    wxTpl(): WxTpl | null {
      if (this.scheduleRule.scheduleMsg) {
        return this.scheduleRule.scheduleMsg.WxTpl; 
      } else {
        return null;
      }
    },
    wxTemplateId(): string | null {
      return this.wxTpl() ? this.wxTpl()!.templateId : null;
    },
    scheduleMsg(): ScheduleMsg | undefined {
      return this.scheduleRule.scheduleMsg;
    },
    hasSetMsg(): boolean {
      return this.scheduleRule.scheduleMsg !== undefined;
    },
    confirmCustomerFilter() {
      this.showSelectTargetPage = false;
      this.hasSetCustomers = true;
      this.cFilter = JSON.parse(JSON.stringify(this.customerFilter));
    },
    confirmCreate() {
      const queries = {};
      if (this.validateCreate()) {
        this.creating = true;
        const ruleContext = JSON.parse(JSON.stringify(this.scheduleRule.ruleContext));
        ruleContext.Periodic.query = format.mkFilterQueries(this.customerFilter);
        if (this.scheduleRule.scheduleMsg.WxTpl) {
          const keys = Object.keys(this.scheduleRule.scheduleMsg.WxTpl.params);
          keys.forEach((i) => {
            this.scheduleRule.scheduleMsg.WxTpl.params[i].value = transDiv(transValue(this.tranProps, this.scheduleRule.scheduleMsg.WxTpl.params[i].value));
          });
        }
        const queries = {
          ruleName: this.scheduleRule.ruleName!,
          ruleType: ScheduleRuleType.Periodic,
          ruleContext: ruleContext,
          scheduleMsg: this.scheduleRule.scheduleMsg!,
        };
        if (this.scheduleRule.id) {
          (queries as any)['id'] = this.scheduleRule.id;
          ruleClient.updateRule(queries).success(r => {
            this.$Message.success('修改成功');
            setTimeout(() => {
              this.$emit('success');
            }, 100);
          }).failure((code: string, msg?: string) => {
            this.$Message.error(msg);
            this.creating = false;
          }).error((e) => {
            this.$Message.error(e.toString());
            this.creating = false;
          });
        } else {
          ruleClient.createRule(queries).success(r => {
            this.$Message.success('创建成功');
            setTimeout(() => {
              this.$emit('success');
            }, 100);
          }).failure((code: string, msg?: string) => {
            this.$Message.error(msg);
            this.creating = false;
          }).error((e) => {
            this.$Message.error(e.toString());
            this.creating = false;
          });
        }
      }
    },
    validateCreate() {
      if (!this.scheduleRule.ruleName || (this.scheduleRule.ruleName! as string).trim() === '') {
        this.$Message.warning('请设置规则名称');
        return false;
      } else if (!this.hasSetCustomers) {
        this.$Message.warning('请筛选用户群');
        return false;
      } else if (!this.hasSetFreq()) {
        this.$Message.warning('请设置推送频率');
        return false;
      } else if (this.showScheduleMsg ||
        this.scheduleRule.scheduleMsg === undefined) {
        this.$Message.warning('请设置模板消息');
        return false;
      } else {
        return true;
      }
    },
  },
  beforeMount() {
    if (!this.scheduleRule.ruleContext.Periodic.freq) {
      this.$store.commit('INIT_CUSTOMER_FILTER');
      this.$store.commit('INIT_CUSTOMER_QUERY');
    }
  },
  mounted() {
    if (this.scheduleRule.ruleContext.Periodic.freq) {
      this.hasSetCustomers = true;
    }
    this.loadExtraData();
    this.cFilter = JSON.parse(JSON.stringify(this.customerFilter)); 
  },
});
